import { Injectable } from '@angular/core';
import { ToastService } from '@captiveaire/toast';
import { IClipboardService } from '../../src/typings/services';

@Injectable({
    providedIn: 'root'
})
export class ClipboardService implements IClipboardService {
    public static $name = 'clipboardService';

    constructor(private toastService: ToastService) { }

    public copyToClipboard(copyText: string, textName: string = 'Text') {
        const el = document.createElement('textarea');

        el.value = copyText;
        el.setAttribute('readonly', '');
        (el as any).style = { position: 'absolute', left: '-9999px' };
        document.body.appendChild(el);
        // Select text inside element
        el.select();
        // Copy text to clipboard
        document.execCommand('copy');
        // Remove temporary element
        document.body.removeChild(el);

        this.toastService.showSimple(`${textName} Copied To Clipboard`);
    }
}
